import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Icon, Row, Text } from '..'
import {
  hasPrice,
  hasPriceUnkown,
  hasNoPrice,
  waitingForNextPriceTry,
} from '../../../common/lib/credit'
import { useNoPriceInstructionsText } from '../../hooks/useNoPriceInstructionsText'

const StyledIcon = styled(Icon)`
  color: ${p => p.color || p.theme.colors.orderListIcons};
  margin-right: 0.5rem;
`

const PriceTag = ({ row, showNoPriceInstructions, showDescription = false }) => {
  const { t } = useTranslation()
  const noPriceInstructionsText = useNoPriceInstructionsText(row)

  if (!hasPrice(row) && !showNoPriceInstructions) return null

  // if (row.priceFetchLastTryAt && hasNoPrice(row)) {
  //   console.log('!!!!>>>', row.priceFetchLastTryAt, row, waitingForNextPriceTry(row))
  // }

  return (
    <Row.Modern alignItems="center">
      <StyledIcon
        color={
          hasPrice(row)
            ? ''
            : waitingForNextPriceTry(row)
            ? 'orange'
            : hasPriceUnkown(row)
            ? 'orange'
            : ''
          // hasPrice(row)
          //   ? 'green'
          //   : waitingForNextPriceTry(row)
          //   ? 'red'
          //   : hasPriceUnkown(row)
          //   ? 'orange'
          //   : 'grey'
        }
        popoverText={noPriceInstructionsText}
        name="MdPricetag"
        size={22}
      />
      {showDescription && (
        <Text>
          {hasPrice(row) ? t('omega; hp pricetag - price:') : ''}
          &nbsp;
          {noPriceInstructionsText}
        </Text>
      )}
    </Row.Modern>
  )
}

export default PriceTag
